import React from "react";
import {
  Dumbbell,
  Heart,
  Activity,
  Calendar,
  Users,
  Trophy,
  Smartphone,
  BarChart,
} from "lucide-react";
import IndustryPageTemplate from "../components/IndustryPageTemplate";

const SERVICE_OFFERINGS = [
  {
    title: "Fitness Tracking Apps",
    description:
      "Build workout tracking with exercise libraries and progress monitoring",
    icon: Activity,
  },
  {
    title: "Gym Management Systems",
    description:
      "Comprehensive platforms for gym operations and member management",
    icon: Dumbbell,
  },
  {
    title: "Virtual Training Platforms",
    description: "Live and on-demand workout streaming solutions",
    icon: Users,
  },
  {
    title: "Nutrition & Diet Apps",
    description: "Meal planning, calorie tracking, and nutrition guidance",
    icon: Heart,
  },
  {
    title: "Wearable Integration",
    description: "Connect with fitness wearables and health devices",
    icon: Smartphone,
  },
  {
    title: "Class Booking Systems",
    description: "Schedule and book fitness classes and personal training",
    icon: Calendar,
  },
  {
    title: "Gamification & Challenges",
    description: "Engagement features with achievements and competitions",
    icon: Trophy,
  },
  {
    title: "Health Analytics",
    description: "Dashboards for fitness progress and health insights",
    icon: BarChart,
  },
];

const STATS = [
  { value: "5M+", label: "Active Users" },
  { value: "100+", label: "Fitness Apps" },
  { value: "1B+", label: "Workouts Logged" },
  { value: "40%", label: "Retention Boost" },
];

const FitnessIndustryPage = () => {
  return (
    <IndustryPageTemplate
      industrySlug="fitness"
      industryTitle="Fitness"
      industrySubtitle="& Wellness"
      heroDescription="Powering the fitness industry with innovative workout apps, gym management systems, and wellness platforms that help people achieve their health goals."
      themeColor="#ea580c"
      themeColorLight="#fb923c"
      themeGradient="linear-gradient(135deg, #7c2d12 0%, #c2410c 50%, #ea580c 100%)"
      HeroIcon={Dumbbell}
      stats={STATS}
      serviceOfferings={SERVICE_OFFERINGS}
      heroImage={
        "https://images.unsplash.com/photo-1745872708309-98f3f13bb842?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
      }
    />
  );
};

export default FitnessIndustryPage;
